import { render, staticRenderFns } from "./ClaimByLossDate.vue?vue&type=template&id=90668444&"
import script from "./ClaimByLossDate.vue?vue&type=script&lang=js&"
export * from "./ClaimByLossDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports